App = require './views/App'

Shared = {
  header: require('./views/shared/header')
}

view = (view_name) ->
  require("./views/#{view_name}")

componentize = (view_name, options = {}) ->
  options.include_header ?= true

  component = options.component || {}

  component.app ?= view(view_name)
  component.header = Shared.header if options.include_header

  component

companyGuard = (to, from, next) ->
  (response) =>
    if !to.meta.no_auth_allowed && (response && response.status == 401)
      Session.logout()
      next name: 'landing'
    else next()
    Loader.off()

emailGuard = (to, from, next) ->
  window.parent.postMessage { type: "message-ui-v1", route: to.path }, "*" if window.parent
  MixpanelCtrl.trackEvent(to.matched[to.matched.length - 1].path, { path: to.fullPath })
  if !to.meta.no_auth_allowed
    if Session.authorized
      if Session.current_user.requireEmailAuthorization()
        if to.meta.email_service_allowed then next() else next name: 'email-config'
      else
        next()
    else
      next name: 'landing'
  else
    if Session.authorized
      if to.meta.signed_user_allowed then next() else next name: 'contatos/leads'
    else
      next()

sessionGuard = (to, from, next) ->
  Loader.on()
  if Session.current_user
    new UsersResource().reloadSession companyGuard(to, from, next), id: Session.current_user.id
  else
    Loader.off()
    next()

exports.guards = {
  company: companyGuard
  email: emailGuard
  session: sessionGuard
}

exports.routes = [
  # meta params:
  # no_auth_allowed -> paths that can be accessed only without session authentication
  # email_service_allowed -> paths that do not require email service authentication
  # signed_user_allowed -> no_auth_allowed paths that can also be accessed when authenticated
  {
    path: '/auth',
    component: App,
    meta: { no_auth_allowed: true },
    children: [
      {
        name: 'landing',
        path: 'login',
        components: componentize('sessions/login', include_header: false)
        meta: { no_auth_allowed: true }
      },
      {
        path: 'recuperar-senha',
        components: componentize('sessions/recover_password', include_header: false)
        meta: { no_auth_allowed: true }
      },
      {
        path: 'redefinir-senha',
        components: componentize('sessions/reset_password', include_header: false)
        meta: { no_auth_allowed: true }
      },
      {
        name: 'invite',
        path: 'convite',
        components: componentize('users/activation', include_header: false)
        meta: { no_auth_allowed: true, signed_user_allowed: true }
      }
    ]
  },
  {
    name: 'root',
    path: '/',
    component: App,
    children: [
      {
        name: 'tasks',
        path: '/tarefas',
        components: componentize('manual_tasks/index')
      },
      {
        path: '/notificacoes',
        components: componentize('shared/notifications/index')
      },
      {
        path: '/fluxos-de-cadencia/criar',
        components: componentize('flows/new')
      },
      {
        path: '/fluxos-de-cadencia/criar/:id',
        components: componentize('flows/new')
      },
      {
        path: '/fluxos-de-cadencia/opcoes-de-criacao',
        components: componentize('flows/creation_options')
      },
      {
        path: '/fluxos-de-cadencia/biblioteca',
        components: componentize('flows/library')
      },
      {
        path: '/fluxos-de-cadencia/:id/editar',
        components: componentize('flows/edit')
      },
      {
        path: '/fluxos-de-cadencia/:id',
        components: componentize('flows/show')
      },
      {
        name: 'flows',
        path: '/fluxos-de-cadencia',
        components: componentize('flows/index')
      },
      {
        path: '/templates',
        components: componentize('templates/index')
      },
      {
        path: '/templates/criar',
        components: componentize('templates/new')
      },
      {
        path: '/templates/criar/:template_id',
        components: componentize('templates/new')
      },
      {
        path: '/templates/:id/editar',
        components: componentize('templates/edit')
      },
      {
        path: 'contatos/importar/manualmente'
        components: componentize('contacts/import/manually'),
      },
      {
        path: 'contatos/importar/csv'
        components: componentize('contacts/import/csv'),
      },
      {
        path: '/contatos',
        components: componentize('contacts/index'),
        children: [
          {
            name: 'contatos/leads'
            path: 'leads'
            components:
              content: view('contacts/leads')
          },
          {
            path: 'grupos'
            components:
              content: view('contacts/groups')
          },
          {
            path: 'empresas'
            components:
              content: view('contacts/businesses')
          },
          {
            path: 'empresas/:id'
            components:
              content: view('businesses/show')
          }
        ]
      },
      {
        path: 'grupos'
        components: componentize('contacts/groups')
      },
      {
        path: 'empresas'
        components: componentize('contacts/businesses')
      },
      {
        path: 'contatos/:id'
        components: componentize('contacts/show'),
      },
      {
        path: 'grupos-de-contatos/importar/manualmente',
        components: componentize('contacts/import/manually'),
        props:
          app: (route) -> ({ has_groups: true })
      },
      {
        path: 'grupos-de-contatos/importar/csv'
        components: componentize('contacts/import/csv'),
        props:
          app: (route) -> ({ has_groups: true })
      },
      {
        path: 'grupos-de-contatos/:id/editar'
        components: componentize('contact_groups/edit'),
      },
      {
        name: 'email-config',
        path: '/configurar-email',
        components: componentize('configuration/index_nylas')
        meta: { email_service_allowed: true }
      },
      {
        name: 'integrations'
        path: '/configuracoes/integracoes'
        components: componentize('configuration/integrations')
        meta: { email_service_allowed: true }
      },
      {
        name: 'integration'
        path: '/configuracoes/integracao'
        meta: { email_service_allowed: true }
        components: componentize('configuration/integrations/index')
      },
      {
        path: '/configuracoes/empresas'
        meta: { email_service_allowed: true }
        components: componentize('companies/index')
      },
      {
        path: '/configuracoes/empresas/criar'
        meta: { email_service_allowed: true }
        components: componentize('companies/new')
      },
      {
        path: '/configuracoes/empresas/:id/editar'
        components: componentize('companies/edit')
      },
      {
        path: '/configuracoes',
        components: componentize('configuration/index')
        meta: { email_service_allowed: true }
        children: [
          {
            path: 'perfil'
            meta: { email_service_allowed: true }
            components:
              content: view('configuration/profile')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'permissoes'
            meta: { nylas_allowed: true }
            components:
              content: view('configuration/permissions')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'alterar-senha'
            meta: { email_service_allowed: true }
            components:
              content: view('configuration/change_password')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'usuarios'
            meta: { email_service_allowed: true }
            components:
              content: view('users/index')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'usuarios/convidar'
            meta: { email_service_allowed: true }
            components:
              content: view('users/invitation_form')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'templates'
            components:
              content: view('template_categories/index')
              sidebar: view('configuration/sidebar')
          },
          {
            name: 'lost_reason'
            path: 'motivo-de-perda'
            components:
              content: view('lost_reason/index')
              sidebar: view('configuration/sidebar')
          },
          {
            name: 'meetings'
            path: 'atividades'
            components:
              content: view('meetings/index')
              sidebar: view('configuration/sidebar')
          },
          {
            name: 'voip'
            path: 'voip'
            components:
              content: view('configuration/voip')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'empresas'
            meta: { email_service_allowed: true }
            components:
              content: view('companies/index')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'empresas/criar'
            meta: { email_service_allowed: true }
            components:
              content: view('companies/new')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'empresas/:id/editar'
            components:
              content: view('companies/edit')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'tags'
            components:
              content: view('tags/index')
              sidebar: view('configuration/sidebar')
          },
          {
            path: 'contatos/campos-personalizados'
            components:
              content: view('custom_fields/index')
              sidebar: view('configuration/sidebar')
          }
        ]
      },
      {
        name: 'migracao',
        path: '/migracao',
        components: componentize('old_reev', include_header: false)
        meta: { email_service_allowed: true }
      },
      {
        path: '*',
        redirect:
          name: 'contatos/leads'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes.coffee